module.exports = __webpack_public_path__ + "media/images/steps_background-a36fa7450d3cd16cad25b1b36355a304.png";